import {FC} from 'react'
import {storeBooking} from "../../lib/booking";
import {useNavigate} from "react-router-dom";
import {bookingFlows} from "../../constants/global";
import {getNextStep, isStepFulfilled} from "../../lib/booking";
import findMenuItem from "../../lib/find-menu-item";

interface Props {
    booking:Booking,
    setBooking:Function,
    content:Content
}

const DateCarousel: FC<Props> = ({booking, setBooking, content}) => {
    const navigate = useNavigate();
    const bookingFlow = bookingFlows[booking.booking_flow]
    const activeStep = bookingFlow.step
    const next = getNextStep(bookingFlow.menu, activeStep)
    const stepFullFilled = isStepFulfilled(activeStep, booking)

    const handleClick = (slide: any) => {
        if(booking.calendar_carousel.index + slide === booking.calendar_carousel.steps.length) {
            if(isStepFulfilled(activeStep, booking)) {
                const item = findMenuItem(next, content)
                booking.page = item.slug
                navigate('/' + item.slug)
            }
        }

        const index = Math.max(0, Math.min(booking.calendar_carousel.index + slide, booking.calendar_carousel.steps.length - 1))
        if (booking.calendar_carousel.steps[index].active) {
            booking.calendar_carousel.index = index
            storeBooking(booking, setBooking)
        }
    }

    let cls = "date-carousel"
    if(booking.calendar_carousel.index < booking.calendar_carousel.steps.length - 1 && booking.calendar_carousel.steps[booking.calendar_carousel.index+1].active)
        cls += " next"

    if(booking.calendar_carousel.index === booking.calendar_carousel.steps.length -1 && stepFullFilled)
        cls += " next"


    if(booking.calendar_carousel.index>0)
        cls += " prev"

    const showForFlows = ["default", "window"];
    if(!showForFlows.includes(booking.booking_flow))
        return <></>

    if(booking.booking_flow === 'window' && booking.window.form.window_damage_type === 'chip' && booking.serviceArray.length === 1)
        return <></>

    return (
        <>
            <div className={cls}>
                <div className={'date-carousel__prev'} onClick={e => handleClick(-1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                         stroke="currentColor">
                        <path d="M19.5 8.25l-7.5 7.5-7.5-7.5"></path>
                    </svg>
                </div>
                <div className={'date-carousel__pagination'}>
                    <div className={'date-carousel__pagination-content'}>
                        {booking.calendar_carousel.index+1}/{booking.calendar_carousel.steps.length}
                    </div>
                </div>
                <div className={'date-carousel__next'} onClick={e => handleClick(1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                         stroke="currentColor">
                        <path d="M19.5 8.25l-7.5 7.5-7.5-7.5"></path>
                    </svg>
                </div>
            </div>
        </>
    )
};

export default DateCarousel
